import { useMutation } from "@tanstack/react-query";
import artificialInstance from "api/aiInstance";

const useUploadAttachment = () => {
    const { mutateAsync, data, isPending } = useMutation({
        mutationKey: ["upload-attachment"],
        mutationFn: async (file: File) => {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("kind", "document");

            const result = await artificialInstance.post(
                `v1/attachments`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                },
            );
            return result?.data;
        },
    });
    return {
        uploadAttachment: mutateAsync,
        attachment: data,
        isUploading: isPending,
    };
};

export default useUploadAttachment;
